import { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  TextField,
  Button,
  Loading,
} from "../../../components";
import { InputErros, PermisoesHelper } from "../../../helpers";
import RotaService from "../../../services/api/rota.service";
import { Rota } from "./entities/rota.entity";
import rotaValidator from "./middlewares/rota.validator";
import { notification } from "../../../services";
import { responseErros } from "../../../utils";

const AddRotas = ({ id, handleCloseDialog, openDialog, buscaRotas }) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-pessoas-visualizar");
  const [loading, setLoading] = useState(false);
  const [rota, setRota] = useState({});
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const rotaService = new RotaService();

  useEffect(() => {
    if (openDialog) {
      if (!id) return;

      buscaRota();
    }
  }, [openDialog]);

  const buscaRota = async () => {
    setLoading(true);
    const result = await rotaService.getById(id);
    if (!result.isAxiosError) {
      setRota(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    e.persist();
    setRota((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const rotaDto = new Rota(rota);
    rotaValidator
      .validate(rotaDto, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await rotaService.atualizar(id, rotaDto);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            handleCloseDialog();
            buscaRotas();
          } else responseErros(response);
        } else {
          const response = await rotaService.cadastrar(rotaDto);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            buscaRotas();
            handleCloseDialog();
          } else responseErros(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  return (
    <Container>
      <Card className="p-3">
        <CardHeader title={rota?.id ? "Editar rota" : "Cadastrar rota"} />
        <CardContent>
          <Grid spacing={2}>
            <TextField
              id="descricao"
              name="descricao"
              label="Descrição"
              variant="outlined"
              margin="normal"
              value={rota?.descricao ? rota.descricao : ""}
              onChange={(e) => {
                setInputErro([]);
                handleInputChange(e);
              }}
              fullWidth
              required
              error={inputErros.get("descricao")}
            />
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            id="botaoSalvar"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            disabled={!permissoesHelper.temPermisao("rotas-cadastrar")}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button
            color="inherit"
            variant="contained"
            onClick={handleCloseDialog}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </Container>
  );
};

export default AddRotas;
